export default "__VITE_ASSET__CKxfhpon__"